import { type ObjectValuesUnionType } from '../utils/typing';

export const DesktopNavigationBarTypes = Object.freeze({
  HOME: 'HOME',
  LIVE: 'LIVE',
  MY_BETS: 'MY_BETS',
  EXTRAS: 'EXTRAS',
  MONOPOLY: 'MONOPOLY',
  BOOM: 'BOOM',
});

export type DesktopNavigationBarType = ObjectValuesUnionType<typeof DesktopNavigationBarTypes>;
